import {
  BOOKKEEPING,
  BOOKKEEPING_MANAGE,
  BOOKKEEPING_SOFTWARE,
  BOOKKEEPING_SOFTWARE_MANAGE,
  BOOKKEEPING_V2,
  BOOKKEEPING_V2_MANAGE,
  BOOKS_PLUS_PLAN,
  BOOKS_PLUS_PLAN_MANAGE,
  FRACTIONAL_PAYROLL_ADMINISTRATOR,
  FRACTIONAL_PAYROLL_ADMINISTRATOR_MANAGE,
  GROUP_BOOKS_CONSOLIDATION,
  GROUP_BOOKS_CONSOLIDATION_MANAGE,
  MAILROOM,
  MAILROOM_MANAGE,
  PLATFORM,
  REGISTERED_AGENT,
  REGISTERED_AGENT_MANAGE,
  SALES_TAX_FILING,
} from "constants/addons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/store";
import { BookkeepingPlan } from "./BookkeepingPlan";
import { BooksSoftware } from "./BooksSoftware";
import { MailRoom } from "./MailRoom";
import { BookKeepingProManage } from "./ManageModals/BookKeepingProManage";
import { BooksSoftwareManage } from "./ManageModals/BooksSoftwareManage";
import { MailRoomManage } from "./ManageModals/MailRoomManage";
import { RegisteredAgentManage } from "./ManageModals/RegisteredAgentManage";
import { RegisteredAgent } from "./RegisteredAgent";
import { GroupConsolidation } from "./GroupConsolidation";
import { GroupConsolidationManage } from "./ManageModals/GroupConsolidationManage";
import BookkeepingPlusPlan from "./BookkeepingPlusPlan";
import BookkeepingPlusPlanManage from "./ManageModals/BookkeepingPlusPlanManage";
import { SubscriptionModal } from "components/SubscriptionModal/SubscriptionModal";
import { setAddonData, setAddonType } from "store/slices/addons";
import { BookkeepingService } from "./BookkeepingService";
import { BookkeepingServiceManage } from "./BookkeepingServiceManage";
import { SalesTaxFilingSubscribe } from "./SalesTaxFilingSubscribe";
import { FractionalPayrollAdministrator } from "./FractionalPayrollAdministrator";
import { FractionalPayrollAdministratorManage } from "./ManageModals/FractionalPayrollAdministratorManage";

export const AddonsModal = () => {
  const { addonType } = useSelector((state: RootState) => state.addonsSlice);
  const dispatch = useDispatch();
  switch (addonType) {
    case BOOKKEEPING_SOFTWARE: {
      return <BooksSoftware />;
    }
    case BOOKKEEPING: {
      return <BookkeepingPlan />;
    }
    case BOOKKEEPING_V2: {
      return <BookkeepingService />;
    }
    case REGISTERED_AGENT: {
      return <RegisteredAgent />;
    }
    case MAILROOM: {
      return <MailRoom />;
    }
    case GROUP_BOOKS_CONSOLIDATION: {
      return <GroupConsolidation />;
    }
    case SALES_TAX_FILING: {
      return <SalesTaxFilingSubscribe />;
    }
    case FRACTIONAL_PAYROLL_ADMINISTRATOR: {
      return <FractionalPayrollAdministrator />;
    }
    case FRACTIONAL_PAYROLL_ADMINISTRATOR_MANAGE: {
      return <FractionalPayrollAdministratorManage />;
    }
    case BOOKKEEPING_SOFTWARE_MANAGE: {
      return <BooksSoftwareManage />;
    }
    case BOOKKEEPING_MANAGE: {
      return <BookKeepingProManage />;
    }
    case BOOKKEEPING_V2_MANAGE: {
      return <BookkeepingServiceManage />;
    }
    case REGISTERED_AGENT_MANAGE: {
      return <RegisteredAgentManage />;
    }
    case MAILROOM_MANAGE: {
      return <MailRoomManage />;
    }
    case GROUP_BOOKS_CONSOLIDATION_MANAGE: {
      return <GroupConsolidationManage />;
    }
    case BOOKS_PLUS_PLAN:
      return <BookkeepingPlusPlan />;

    case BOOKS_PLUS_PLAN_MANAGE:
      return <BookkeepingPlusPlanManage />;

    case PLATFORM:
      return (
        <SubscriptionModal
          show={true}
          onClose={() => {
            dispatch(setAddonData(""));
            dispatch(setAddonType(""));
          }}
        />
      );
    default:
      return <></>;
  }
};
